<template>
  <div>
    <div class="form-group" style="margin-bottom: 4px;">
      <div class="input-group" style="display: flex;">
        <input
          type="text"
          class="form-control"
          placeholder="Search Campaign ID"
          v-model="searchTerm"
        />
        <div class="input-group-append">
          <button
            class="btn btn-primary"
            type="button"
            id="button-addon2"
            style="border-radius: 0px;"
            @click="searchCampaign()"
          >
            Search
          </button>
        </div>
      </div>
    </div>
    <p style="color: red; font-size: 12px;" v-if="notFound">Campaign could not be found.</p>
    <p style="color: red; font-size: 12px;" v-if="error">An error occured while searching for the campaign.</p>
  </div>
</template>
<script>
import CampaignServiceV2 from '../../services/V2/CampaignServiceV2';

export default {
  data() {
    return {
      searchTerm: '',
      notFound: false,
      error: false,
    };
  },
  methods: {
    async searchCampaign() {
      this.$emit('on-search');

      this.notFound = false;
      this.error = false;

      try {
        const response = await CampaignServiceV2.getAdminCampaign(
          this.searchTerm
        );
        if (response.data && response.data.data) {
          this.$emit('on-campaign-found', response.data.data);
        }
      } catch (error) {
        if (
          error &&
          error.response &&
          error.response.status &&
          error.response.status === 404
        ) {
          this.notFound = true;
          return;
        }
        
        this.error = true;
      }
    },
  },
};
</script>
